import _classCallCheck from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { BreakpointNotFoundError, NextBreakpointNotFoundError } from './errors';

var Media =
/*#__PURE__*/
function () {
  function Media(sizes) {
    _classCallCheck(this, Media);

    this.sizes = sizes;
    this.sizes = sizes;
  }

  _createClass(Media, [{
    key: "isBreakpoint",
    value: function isBreakpoint(breakpoint) {
      return Boolean(this.sizes[breakpoint]);
    }
  }, {
    key: "next",
    value: function next(breakpoint) {
      var keys = Object.keys(this.sizes);
      var index = keys.indexOf(breakpoint);
      return keys[index + 1];
    }
  }, {
    key: "up",
    value: function up(breakpoint) {
      if (!this.isBreakpoint(breakpoint)) {
        throw new BreakpointNotFoundError(breakpoint);
      }

      return "@media (min-width: " + this.sizes[breakpoint] + "px)";
    } // The max-width value is calculated as the next breakpoint less 0.02px.
    // See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
    // Uses 0.02px rather than 0.01px to work around a current rounding bug
    // in Safari. See https://bugs.webkit.org/show_bug.cgi?id=178261

  }, {
    key: "down",
    value: function down(breakpoint) {
      if (!this.isBreakpoint(breakpoint)) {
        throw new BreakpointNotFoundError(breakpoint);
      }

      var nextBreakpoint = this.next(breakpoint);

      if (!this.isBreakpoint(nextBreakpoint)) {
        throw new NextBreakpointNotFoundError(breakpoint);
      }

      return "@media (max-width: " + (this.sizes[nextBreakpoint] - 0.02) + "px)";
    }
  }, {
    key: "between",
    value: function between(min, max) {
      if (!this.isBreakpoint(min)) {
        throw new BreakpointNotFoundError(min);
      }

      if (!this.isBreakpoint(max)) {
        throw new BreakpointNotFoundError(max);
      }

      return "@media (min-width: " + this.sizes[min] + "px) and (max-width: " + (this.sizes[max] - 0.02) + "px)";
    }
  }, {
    key: "only",
    value: function only(breakpoint) {
      var nextBreakpoint = this.next(breakpoint);
      return this.isBreakpoint(nextBreakpoint) ? this.between(breakpoint, nextBreakpoint) : this.up(breakpoint);
    }
  }]);

  return Media;
}();

var mediaHelper = function mediaHelper(sizes) {
  return new Media(sizes);
};

export { Media, mediaHelper };